import { useState } from "react";
import { DotLegalSelect } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "../../../localization/useTranslation.ts";
import { ContractStatus } from "../../Contracts.types.ts";
import { getEnumValues } from "@common/enumOperations.ts";
import ArchiveContractDialog from "../archiveContractDialog/ArchiveContractDialog.tsx";

export interface ContractStatusFieldProps {
    /** Lets a caller that owns the vertical rhythm itself turn the field's own margin off. */
    noMargin?: boolean;
    /** Suppresses the field's help icon, for a view where the same field is shown twice. */
    hideToolTip?: boolean;
    status?: ContractStatus;
    onChange: (status: ContractStatus) => void;
    readOnly?: boolean;
    disabled: boolean;
    errorText?: string;
    isLoading: boolean;
    contractId: string;
    contractEndDate?: Date;
    contractStartDate?: Date;
    onRefetchContract: () => void;
}

function ContractStatusField(props: ContractStatusFieldProps) {
    const { translateString, translateContractStatusEnum } = useTranslation();
    const [showArchiveDialog, setShowArchiveDialog] = useState(false);

    function handleChange(type: string | null) {
        if (props.readOnly) return;

        const status = Number(type) as ContractStatus;
        if (status === ContractStatus.Archived && props.status !== ContractStatus.Archived) {
            setShowArchiveDialog(true);
        } else {
            props.onChange(status);
        }
    }

    return (
        <>
            <DotLegalSelect
                noMargin={props.noMargin}
                options={getEnumValues(ContractStatus).map((x) => {
                    return { id: x.toString(), name: translateContractStatusEnum(x.toString()) };
                })}
                selectedItem={props.status?.toString()}
                onChange={props.readOnly ? () => {} : handleChange}
                placeholder={translateString("status")}
                label={translateString("status")}
                noOptionsLabel={translateString("noOptions")}
                toolTipText={props.hideToolTip ? undefined : translateString("contractStatusInfo")}
                disabled={props.disabled}
                errorText={props.errorText}
                disableClearable
                isLoading={props.isLoading}
            />
            {showArchiveDialog && (
                <ArchiveContractDialog
                    contractId={props.contractId}
                    contractEndDate={props.contractEndDate}
                    contractStartDate={props.contractStartDate}
                    onDialogClose={() => setShowArchiveDialog(false)}
                    onArchived={() => {
                        setShowArchiveDialog(false);
                        props.onRefetchContract();
                    }}
                />
            )}
        </>
    );
}

export default ContractStatusField;
